import { ReactComponent as AdvancesIcon } from 'icons/advances.svg'
import { ReactComponent as CollectionsIcon } from 'icons/collections.svg'
import { ReactComponent as CreditLineIcon } from 'icons/credit-lines.svg'
// import { ReactComponent as InvoiceIcon } from 'icons/invoices.svg'
import { ReactComponent as PaymentsIcon } from 'icons/payment.svg'

export default [
  // { path: '/invoices', name: 'navigation.invoices', icon: InvoiceIcon }, Don't remove
  { path: '/invoices', name: 'navigation.advances', icon: AdvancesIcon },
  { path: '/payments', name: 'navigation.payments', icon: PaymentsIcon },
  {
    path: '/collections',
    name: 'navigation.collections',
    icon: CollectionsIcon,
  },
  {
    path: '/creditlines',
    name: 'navigation.creditlines',
    icon: CreditLineIcon,
  },
]
